import { StrictMode } from 'react'
import { v4 } from 'uuid'
import { createRoot } from 'react-dom/client'
import App from './App'
import { alertsVar } from './providers/apollo/cache'
import reportWebVitals from './reportWebVitals'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'
import logger from './utils/logger'

interface WorkerEventTarget extends EventTarget {
  state?: string | null
}

interface WorkerEvent extends Event {
  target: WorkerEventTarget | null
}

async function initiliazeApp() {
  const container = document.getElementById('root')
  if (!container) {
    throw new Error('Root container missing in index.html')
  }
  const root = createRoot(container)
  root.render(
    <StrictMode>
      <App />
    </StrictMode>
  )

  serviceWorkerRegistration.register({
    onUpdate: (registration) => {
      const waitingServiceWorker = registration.waiting
      if (waitingServiceWorker) {
        waitingServiceWorker.addEventListener('statechange', (event: WorkerEvent) => {
          if (event && event.target?.state === 'activated') {
            alertsVar([{ id: v4(), message: 'Updating Application, Browser will refresh automatically to apply the changes.', severity: 'info' }])
            setTimeout(() => {
              window.location.reload()
            }, 5000)
          }
        })
        waitingServiceWorker.postMessage({ type: 'SKIP_WAITING' })
      }
    }
  })
  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals(logger.debug)
}

initiliazeApp()
